import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { membershipNavigation } from '../../utils/communityNavigation';

const ROLE_LABELS = { community_admin: 'Community administrator', community_staff: 'Community staff', member: 'Community member' };

export default function CommunityHub() {
  const { user, memberships = [] } = useAuth();
  const active = memberships.filter((membership) => membership.status === 'active' && (membership.tenantSlug || membership.tenantId?.slug));
  return <div className="page community-hub">
    <h1>My communities</h1>
    <p>Choose your community, then open the tools available to you.</p>
    {!active.length && <p>No active community memberships. <Link to="/membership">Find or request community membership</Link>.</p>}
    <div className="community-hub__list">
      {active.map((membership) => {
        const slug = membership.tenantSlug || membership.tenantId?.slug;
        const branding = membership.branding || membership.tenantId?.branding;
        const name = branding?.displayName || membership.tenantName || membership.tenantId?.name || slug;
        const links = membershipNavigation(membership, user).flatMap((item) => item.children || [item]);
        return <section key={slug} className="community-hub__community" aria-label={name}>
          <div className="community-hub__identity">
            {branding?.logoUrl && <img src={branding.logoUrl} alt={`${name} logo`} />}
            <div><h2><Link to={`/t/${slug}/dashboard`}>{name}</Link></h2>
              <p>{ROLE_LABELS[membership.communityRole] || 'Community member'}</p></div>
          </div>
          <nav aria-label={`${name} tools`} className="community-tool-links">
            {links.map((link) => <Link key={link.to} to={link.to}>{link.label}</Link>)}
          </nav>
        </section>;
      })}
    </div>
  </div>;
}
